import "./Pages/Dashboard/Dashboard.css"

const About = () => {
    return (
        <div>
            <section className="dashboard-page">
                <h1 className="dashboard-title">Hello! Welcome to EquiVate HR Community Page</h1>

            </section>
        </div>
    
    )

}

export default About